import cx from "classnames";
const PageTitle = ({
  title,
  variant = "large",
  className = "",
  as = "h1"
}) => {
  const HeadingTag = as;
  return <HeadingTag className={cx(`font-heading text-supportiveBlack rtl:font-arabic font-medium ${className}`, {
    "text-xl md:text-2xl": variant === "small",
    "text-xl md:text-4xl": variant === "medium",
    "text-xl md:text-5xl": variant === "large"
  })} data-sentry-element="HeadingTag" data-sentry-component="PageTitle" data-sentry-source-file="PageTitle.jsx">
      {title}
    </HeadingTag>;
};
export default PageTitle;